import { useQuery } from '@apollo/client';
import { loader } from 'graphql.macro';
import { useCurrentUser } from './UserProvider';
import { useOnlineStatus } from '../hooks/offline-hooks/offline-misc';

const hasPermissionQuery = loader('./UsePermissionHook.graphql');

export default function useCheckPermission({ id, model, action, type }) {
  !model && console.warn('No model name in permission hook');
  !action && console.warn('No action in permission hook');

  const { user } = useCurrentUser();
  const online = useOnlineStatus();
  const { data: { checkPermission = false } = {} } = useQuery(
    hasPermissionQuery,
    {
      skip: !user?.id || !online,
      variables: {
        modelId: id,
        modelName: model,
        action,
        type,
      },
    },
  );

  return checkPermission;
}
